"use client";
import { jsxs as a, jsx as i } from "react/jsx-runtime";
const o = ({
  title: e,
  titleId: l,
  desc: r,
  descId: t,
  ...c
}) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": l,
    "aria-describedby": t,
    ...c,
    children: [
      r ? /* @__PURE__ */ i("desc", { id: t, children: r }) : null,
      e ? /* @__PURE__ */ i("title", { id: l, children: e }) : null,
      /* @__PURE__ */ a("g", { stroke: "#3A3A3A", strokeMiterlimit: 10, strokeWidth: 1.5, children: [
        /* @__PURE__ */ i(
          "path",
          {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M6.9 20.6c1.5.9 3.3 1.4 5.1 1.4 5.5 0 10-4.5 10-10S17.5 2 12 2 2 6.5 2 12c0 1.8.5 3.5 1.3 5l-.8596 3.306c-.1947.7489.4985 1.4257 1.2426 1.2131z"
          }
        ),
        /* @__PURE__ */ i("path", { d: "M16.5 14.8485c0 .162-.0361.3285-.1127.4905a1.86 1.86 0 0 1-.3064.459c-.2209.243-.4642.4185-.7391.531-.2704.1125-.5634.171-.8789.171-.4596 0-.9509-.108-1.4692-.3285-.5182-.2205-1.0365-.5175-1.5503-.891a12.95 12.95 0 0 1-1.4782-1.26q-.6963-.702-1.2574-1.4715c-.3695-.513-.667-1.026-.8833-1.5345Q7.5 10.245 7.5 9.543c0-.306.054-.5985.1622-.8685.1082-.2745.2795-.5265.5183-.7515.2884-.2835.604-.423.9374-.423a.85.85 0 0 1 .365.081.734.734 0 0 1 .302.252l1.0456 1.4715c.0811.1125.1397.216.1803.315.0405.0945.0631.189.0631.2745 0 .108-.0316.216-.0947.3195-.0586.1035-.1442.2115-.2524.3195l-.3425.3555c-.0495.0495-.0721.108-.0721.18 0 .036.0045.0675.0135.1035.0136.036.0271.063.0361.09.0811.1485.2208.342.4191.576.2028.234.4191.4725.6535.711.2434.2385.4777.459.7166.6615.2343.198.4281.333.5813.414.0226.009.0496.0225.0812.036.036.0135.0721.018.1126.018a.248.248 0 0 0 .1848-.0765l.3425-.3375c.1127-.1125.2209-.198.3245-.252.1037-.063.2073-.0945.32-.0945.0856 0 .1758.018.2749.0585.0992.0405.2028.099.3155.1755l1.4917 1.0575c.1172.081.1983.1755.2479.288.0451.1125.0721.225.0721.351Z" })
      ] })
    ]
  }
);
export {
  o as default
};
